import { FC } from "react";
import { ModalA } from "../../common/components/ModalA";
import { ButtonA } from "../../common/components/ButtonA";

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const cancelBtnStyle = {
  backgroundColor: "#fff",
  color: "#172952",
  width: "100px",
  fontWeight: 600,
  border: "1.5px solid",
  borderRadius: "50px",
  textTransform: "capitalize",
};

export const UnsavedChangesModal: FC<Props> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  return (
    <ModalA
      title="Unsaved Changes"
      isOpen={isOpen}
      onCloseModal={onCancel}
    >
      <div className="p-4 text-center">
        <p>
          Auto-save is still in progress. Are you sure you want to leave?
        </p>
        <div className="flex flex-row mt-5 justify-center gap-3">
          <ButtonA
            name="Cancel"
            customStyle={cancelBtnStyle}
            onHandleClick={onCancel}
          />
          <ButtonA name="Yes" onHandleClick={onConfirm} />
        </div>
      </div>
    </ModalA>
  );
};
